import FactorsImpactingCosts from "./FactorsImpactingCosts.svg";

export default FactorsImpactingCosts;
